// 转弯模式
export default {
    fixedPoint: 'Повороты с фиксированной точкой',
    coordinate: 'Скоординированные повороты'
}